import dayjs from "dayjs";
import { DateFormatTime } from "@/config";

export const getImageUrl = (imagePath: string) => {
  return new URL(imagePath, import.meta.url).href;
};
const iconBasePath = "../assets/images/divination/icon";
export const icons: Record<string, string> = {
  affection: getImageUrl(`${iconBasePath}/affection.png`),
  character: getImageUrl(`${iconBasePath}/character.png`),
  community: getImageUrl(`${iconBasePath}/community.png`),
  health: getImageUrl(`${iconBasePath}/health.png`),
  money: getImageUrl(`${iconBasePath}/money.png`),
  question: getImageUrl(`${iconBasePath}/question.png`),
  travel: getImageUrl(`${iconBasePath}/travel.png`),
  work: getImageUrl(`${iconBasePath}/work.png`),
  qrcode: getImageUrl("../assets/images/qrcode.png"),
};

export const getQueryString = (locationSearches?: string) => {
  if (!window || !window.location) {
    console.log("error not browser");
    return null;
  }
  let locationSearch: string = locationSearches
    ? locationSearches
    : window.location.search;
  if (!locationSearch && window.location.hash) {
    locationSearch = window.location.hash.substr(
      window.location.hash.lastIndexOf("?")
    );
  }
  const query: Record<string, any> = {};
  if (locationSearch) {
    locationSearch = locationSearch.replace("?", "");
    const params = locationSearch.split("&");
    params.forEach((param, idx) => {
      const keyValue = param.split("=");
      query[keyValue[0]] = decodeURIComponent(keyValue[1]);
    });
  }
  return query;
};

export const getQueryStringByKey = (key: string) => {
  const qs = getQueryString();
  if (qs && Object.keys(qs)) {
    return qs[key];
  }
  return null;
};

export const mobileReg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;

export const getBbsDate = (date?: string) => {
  if (!date) {
    return "";
  }
  try {
    return dayjs(date).format(DateFormatTime);
  } catch {
    return "";
  }
};

/**
 * 获取性别显示文字
 * 0是未知1是男2是女
 */
export const getSexName = (sex?: number | string) => {
  if (!sex) {
    return "";
  }
  if (sex.toString() === "1") {
    return "男";
  } else if (sex.toString() === "2") {
    return "女";
  } else {
    return "";
  }
};

export const getPrice = (price: string) => {
  return Number.parseInt(price || "0") / 100;
};

export const getDateInfo = (value: Date) => {
  const date = dayjs(value);
  return {
    year: parseInt(date.format("YYYY"), 10),
    month: parseInt(date.format("MM")) - 1,
    day: parseInt(date.format("DD")),
  };
};

export const formatStrRNToBr = (value?: string) => {
  return value?.replace(/\r|\n/gi, "<br/>").replace(/<br\/><br\/>/gi, "<br/>");
};
